import { FilterChip, useQueryParams } from '@marqvision/shared';
import { useLogger } from '~/hooks';
import { FilterQueryParams } from '~/pages/DomainNames/@types';

export const LogoDetectedFilter = () => {
  const { amplitudeLogging } = useLogger();
  const filterParams = useQueryParams<FilterQueryParams>();

  const currentValue = filterParams.params.logo_detection_filter;

  const handleChange = () => {
    filterParams.setParams({ logo_detection_filter: currentValue ? null : true });

    if (currentValue) {
      amplitudeLogging('applied filter', {
        Type: 'tm logo',
        Channel: 'domain names',
        Page: 'domain list',
      });
    }
  };

  return (
    <FilterChip type="toggle" color="bluegray" label="Logo detected" selected={!!currentValue} onClick={handleChange} />
  );
};
